import React, { Component } from 'react'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

import './Maps.css'
 
export class MapContainer extends Component {
    render() {
        return (
            <div className='maps'>
                <Map 
                    google={this.props.google} 
                    zoom={16} 
                    style={{width: "100%", height: '100%', overflow: 'hidden', position: 'relative'}}
                    initialCenter={
                        {
                            lat: 10.028364684048315,
                            lng: 76.3285068284582
                        }
                    }
                    className='map'
                >
                    <Marker 
                        position={{
                            lat: 10.028364684048315,
                            lng: 76.3285068284582
                        }} 
                        title="Model Engineering College, Thrikkakara"
                    />
                </Map>
            </div>
        );
    }
}
 
export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API
})(MapContainer)